module.exports = __webpack_public_path__ + "img/13.441a3a93.jpg";